/**
 * useWcModeVisibility(mode, platform)
 *
 * Hook that returns the effective visibility for a (mode, platform) pair.
 * Returns:
 *   - loading:  true while the call is in flight
 *   - visible:  raw db value (false unless admin flipped it)
 *   - effective: true if user is staff OR the raw flag is true
 *   - isStaff
 *
 * Admin/mod always sees the mode regardless of the flag.
 */
import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function useWcModeVisibility(mode, platform = "mobile") {
  const [state, setState] = useState({
    loading: true, visible: false, effective: false, isStaff: false,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get(`/wc/visibility?mode=${mode}&platform=${platform}`);
        if (cancelled) return;
        setState({
          loading: false,
          visible: !!data.visible,
          effective: !!data.effective,
          isStaff: !!data.is_staff,
        });
      } catch (e) {
        if (!cancelled) setState({ loading: false, visible: false, effective: false, isStaff: false });
      }
    })();
    return () => { cancelled = true; };
  }, [mode, platform]);

  return state;
}
